<template>
	<div class="wrapper">
        <!-- Sidebar Holder -->
        <nav id="sidebar">
            <div class="sidebar-header"></div>
            <h4 class="text-muted text-center">{{newMessages?"Tienes nuevos mensajes":""}}</h4>
            <ul class="list-unstyled components" style="height: calc(100% - 85px); overflow: auto">
                <li v-for="contact in contacts" :key="contact.phone">
                    <a v-if="loginSucces" v-on:click="getMessages(contact)">
                        <span>{{contact.user ? contact.name : contact.phone}}</span>
                        <h5 class="text-muted">{{contact.data['Body']}}</h5>
                    </a>
                    <h2 v-else>Sesión inválida, intenta nuevamente</h2> 
                </li>
            </ul>
        </nav>
        <!-- Page Content Holder -->
        <div id="content" style="height: 100%; overflow: hidden">
            <div class="content-header">
                <h3>{{currentContact.user ? currentContact.name : currentContact.phone}}</h3>
            </div>

            <div id="conversation" v-if="loginSucces">
                <div class="row align-content-end p-3">
                    <div class="container" style="overflow: auto" v-for="message in messages" :key="message.id">
                        <div class="row p-1 font-weight-bold" :class="{'justify-content-start': isIncomingMessage(message), 'justify-content-end': !isIncomingMessage(message), 'text-danger': message.data['mediaurl0']}">
                            <div :class="{'rounded-right p-1': isIncomingMessage(message), 'rounded-left p-1': !isIncomingMessage(message)}"
                                :style="isIncomingMessage(message) ? 'background-color: #d8defd; box-shadow: 1px 2px 4px; max-width: 80%;': 'background-color: white; box-shadow: -1px 2px 4px; max-width: 80%;'">
                                    {{message.data['mediaurl0']? "(multimedia)" : message.data['body']}}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div v-if="loginSucces" class="row">
                <div class="col">
                    <base-input placeholder="Escribe un mensaje"
                                class="input-group-alternative"
                                required
                                alternative=""
                                style="width: 104%"
                                v-model="message"
                                v-on:keydown.enter.native="sendMessage(message, false)">
                    </base-input>
                </div>
                <div class="col col-auto">
                    <base-button title="Enviar" style="width: 100%" type="info" icon="far fa-paper-plane" @click="sendMessage(message, false)"></base-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function() {
            return {
                message: "",
                //validMessage: false,
                connection: null,
                contacts: [],
                currentContact: {},
                messages: [],
                newMessages: false,
                loginSucces: false
            }
        },
        methods: {
            isIncomingMessage(message) {
                try {
                    //this.validMessage = true
                    return message.data['from'].split("+")[1] === message.phone
                } catch (e) {
                    //this.validMessage = false
                    console.log("Posibles mensajes omitidos");
                }
            },
            sendMessage(message, isJSON = true) {
                if (!isJSON) {
                    let payload = {
                        action: 'sendmessage',
                        message: message,
                        to: this.currentContact.data['from'].split("+")[1]
                    }
                    message = JSON.stringify(payload)                    
                }else message = JSON.stringify(message)
                //console.log("Enviando:",message);
                this.connection.send(message)
                this.message=""
            },
            messageReceived(json) {
                //console.log("Recibiendo:",json);
                if (!json.action){
                    if(json.consultant){
                        this.getMessages(this.currentContact)
                        this.showLastMessage()
                    }
                    return
                }
                let msg
                switch (json.action) {
                    case 'validateconn':
                        if (json.success) {
                            return
                        }else{
                            console.log("Reconectar");//reconectar
                        }
                        break
                    case 'login':
                        if (json.success) {
                            // Login Success
                            this.loginSucces=true// Habilitar ventana de chat y botón de enviar
                            return
                        }
                        // Notificar al usuario que su sesión es inválida
                        break
                    case 'sendmessage':
                        console.log(json);
                        msg = JSON.parse(json.message)
                        if (msg.data['from'].split("+")[1] === this.currentContact.phone){
                            this.messages.push(msg)
                            this.showLastMessage()
                        } else this.newMessages=true;
                        break
                }
            },
            async getContacts(/*limit, offset*/) {
                try {
                    const url = this.$v.SERVER + this.$v.SELLER_OPS.GET_WHATSAPP_CONTACTS
                    let apiResponse = (await this.$axios.get(url)).data
                    if (apiResponse.success)
                        this.contacts = apiResponse.rows
                    //console.log(apiResponse)
                    //console.log(`${this.contacts.length} contactos`)
                } catch (e) {
                    console.log(e)
                }
            },
            async getMessages(contact) {
                try {
                    const url = `${this.$v.SERVER}${this.$v.SELLER_OPS.GET_WHATSAPP_CHAT}?offset=0&limit=50&phone=${contact.phone}`
                    let apiResponse = (await this.$axios.get(url)).data
                    if (apiResponse.success) {
                        this.messages = apiResponse.rows.reverse()
                        this.currentContact = contact
                        this.newMessages=false
                    }
                } catch (e) {
                    console.log(e)
                }
            },
            showLastMessage(){
                var objDiv = document.getElementById("conversation");
                objDiv.scrollTop = objDiv.scrollHeight;
            }
        },
        created: function(){
            this.getContacts()
            //console.log("Iniciando coneccion webSocket");
            this.connection = new WebSocket("wss://82p2gxte75.execute-api.us-west-1.amazonaws.com/dev")
            //this.connection = new WebSocket("wss://echo.websocket.org")

            const context = this
            this.connection.onmessage = function(event){
                //console.log("Mensaje recibido");
                context.messageReceived(JSON.parse(event.data))
            }
            this.connection.onopen = function(){
                //console.log("Conexion exitosa")
                let {session} = context.$getLS('session')
                if (session)
                    context.sendMessage({
                        action: "setsession",
                        session: session
                    })
            }
        },
    }
    
</script>
<style>


a, a:hover, a:focus {
    color: inherit;
    text-decoration: none;
    transition: all 0.3s;
}
/*.navbar {
    padding: 19px 0px;
    border: none;
    border-radius: 0;
    margin-bottom: 40px;
    box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.1);
}*/
/*.navbar-btn {
    box-shadow: none;
    outline: none !important;
    border: none;
}*/

.line {
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed rgb(170, 11, 11);
    margin: 40px 0;
}

/* ---------------------------------------------------
    SIDEBAR STYLE
----------------------------------------------------- */
#sidebar {
    width: 400px;
    top: 0;
    left: 0;
    height: 100vh;
    z-index: 999;
    background: #ffffff;
    color: rgb(0, 0, 0);
}
#sidebar.active {
    margin-left: -400px;
}

#sidebar h4{
    border-bottom: 1px solid #e9e9e9; 
    background: #c3ccff;
}

#sidebar .sidebar-header {
    padding: 43px;
    background: #3953d3;
}

#sidebar ul li a {
    padding: 10px;
    font-size: 1.1em;
    border-bottom: 1px solid #e9e9e9;
    display: block;
}
#sidebar ul li a:hover {
    color: rgb(0, 0, 0);
    background: rgb(230, 239, 247);
}

#sidebar ul li.active > a, a[aria-expanded="true"] {
    color: #fff;
    background: #6d7fcc;
}

/*a[data-toggle="collapse"] {
    position: relative;
}

a[aria-expanded="false"]::before, a[aria-expanded="true"]::before {
    content: '\e259';
    display: block;
    position: absolute;
    right: 20px;
    font-family: 'Glyphicons Halflings';
    font-size: 0.6em;
}
a[aria-expanded="true"]::before {
    content: '\e260';
}


ul ul a {
    font-size: 0.9em !important;
    padding-left: 30px !important;
    background: #6d7fcc;
}

ul.CTAs {
    padding: 20px;
}

ul.CTAs a {
    text-align: center;
    font-size: 0.9em !important;
    display: block;
    border-radius: 5px;
    margin-bottom: 5px;
}
a.download {
    background: #fff;
    color: #7386D5;
}
a.article, a.article:hover {
    background: #6d7fcc !important;
    color: #fff !important;
}
*/

/* ---------------------------------------------------
    CONTENT STYLE
----------------------------------------------------- */
#content {
    width: calc(100% - 400px);
    padding: 0px;
    min-height: 100vh;
    transition: all 0.3s;
    position: absolute;
    top: 0;
    background: rgb(234, 239, 255);
    right: 0;
}
#content .content-header {
    padding: 10px;
    height: 50px;
    border: none;
    border-radius: 0;
    width: 100%;
    box-shadow: 0px 3px 5px #b3b3b3;
    background: #617af5;
}
#conversation {
    padding: 3px 3px;
    height:calc(100% - 93px);
    overflow-y: auto;
    overflow-x: hidden;
}
#content.active {
    width: 100%;
}


/* ---------------------------------------------------
    MEDIAQUERIES
----------------------------------------------------- */
@media (max-width: 768px) {
    #sidebar {
        margin-left: -400px;
    }
    #sidebar.active {
        margin-left: 0;
    }
    #content {
        width: 100%;
    }
    #content.active {
        width: calc(100% - 400px);
    }
    #sidebarCollapse span {
        display: none;
    }
}
</style>
